module.exports = __webpack_public_path__ + "static/media/invoice-page.c9f4d74a.png";